var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-upload-files',{attrs:{"documento-id":_vm.dataForm.documento_id,"tipo":"pdf","folder":"/documentaciones/contratos","maxSize":5},on:{"documento":function($event){_vm.dataForm.documento_id = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }